// removed by extract-text-webpack-plugin
module.exports = {"root":"HostCarriersTable__root___2G6a-","theTable":"HostCarriersTable__theTable___2K1bE","categoryCol":"HostCarriersTable__categoryCol___32jqr","selectionCol":"HostCarriersTable__selectionCol___1RJMt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/HostCarriersTable/HostCarriersTable.css
// module id = 963
// module chunks = 0